import { useStaticQuery, graphql } from 'gatsby';

const LogoQuery = () => {
    const data = useStaticQuery(graphql`query LogoQuery {
  logo: file(name: {eq: "logo-200w"}) {
    childImageSharp {
      gatsbyImageData(width: 300, layout: CONSTRAINED)
    }
  }
}
`);
    return data.logo;
};

export default LogoQuery;
